import { render, staticRenderFns } from "./EmptyStateDecksIllustration.vue?vue&type=template&id=e2f24160"
import script from "./EmptyStateDecksIllustration.vue?vue&type=script&lang=js"
export * from "./EmptyStateDecksIllustration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports